import { ConfigurationData } from '../../../api/simple-project-service/configurations/useConfigurationApi';
import { ProductParameter } from '../../../interfaces/Parameter';
import { ConfigurationsViewMode } from './ConfiguratorContext';

export enum Actions {
  SET_CONFIGURATION_DATA = 'SET_CONFIGURATION_DATA',
  MERGE_ARTICLE_DEFINITIONS = 'MERGE_ARTICLE_DEFINITIONS',
  SET_CURRENT_CONFIGURATION = 'SET_CURRENT_CONFIGURATION',
  SET_CURRENT_REQUEST_INFO = 'SET_CURRENT_REQUEST_INFO',
  SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT',
  SET_CURRENT_CONFIGURATIONS = 'SET_CURRENT_CONFIGURATIONS',
  SET_CONFIGURATIONS_DATA = 'SET_CONFIGURATIONS_DATA',
  SET_CONFIGURATIONS_VIEW_MODE = 'SET_CONFIGURATIONS_VIEW_MODE',
  SET_SELECTED_CONFIGURATION_IDS = 'SET_SELECTED_CONFIGURATION_IDS',
  SET_CURRENT_REQUESTS = 'SET_CURRENT_REQUESTS',
  SET_SELECTED_REQUEST_IDS = 'SET_SELECTED_REQUEST_IDS',
  SET_DRAFTS = 'SET_DRAFTS',
  SET_VALIDATION_RESULTS = 'SET_VALIDATION_RESULTS',
  SET_PREVIOUSLY_SELECTED_PARAMETERS = 'SET_PREVIOUSLY_SELECTED_PARAMETERS',
  SET_CONFIGURATION_ERROR = 'SET_CONFIGURATION_ERROR',
}

export type Action =
  | {
      type: Actions.SET_CONFIGURATION_DATA;
      payload?: ConfigurationData;
    }
  | {
      type: Actions.MERGE_ARTICLE_DEFINITIONS;
      payload: CoreServiceAPI.ArticleDto[];
    }
  | {
      type: Actions.SET_CURRENT_CONFIGURATION;
      payload: SimpleProjectServiceAPI.ConfigurationDto;
    }
  | {
      type: Actions.SET_CURRENT_REQUEST_INFO;
      payload: SimpleProjectServiceAPI.ConfigurationRequestDto;
    }
  | {
      type: Actions.SET_CURRENT_PROJECT;
      payload: SimpleProjectServiceAPI.ProjectDto;
    }
  | {
      type: Actions.SET_CURRENT_CONFIGURATIONS;
      payload: SimpleProjectServiceAPI.ConfigurationDto[];
    }
  | {
      type: Actions.SET_CONFIGURATIONS_VIEW_MODE;
      payload: ConfigurationsViewMode;
    }
  | {
      type: Actions.SET_SELECTED_CONFIGURATION_IDS;
      payload: string[];
    }
  | {
      type: Actions.SET_CURRENT_REQUESTS;
      payload: SimpleProjectServiceAPI.ConfigurationRequestDto[];
    }
  | {
      type: Actions.SET_DRAFTS;
      payload: Nullable<SimpleProjectServiceAPI.DraftConfigurationDto[]>;
    }
  | {
      type: Actions.SET_VALIDATION_RESULTS;
      payload: Record<string, CoreServiceAPI.ValidationResultDto>;
    }
  | {
      type: Actions.SET_SELECTED_REQUEST_IDS;
      payload: string[];
    }
  | {
      type: Actions.SET_CONFIGURATIONS_DATA;
      payload: Nullable<ConfigurationData[]>;
    }
  | {
      type: Actions.SET_PREVIOUSLY_SELECTED_PARAMETERS;
      payload: ProductParameter[];
    }
  | {
      type: Actions.SET_CONFIGURATION_ERROR;
      payload: any;
    };

const setConfigurationData = (payload?: ConfigurationData): Action => {
  return {
    payload,
    type: Actions.SET_CONFIGURATION_DATA,
  };
};

const mergeArticleDefinitions = (payload: CoreServiceAPI.ArticleDto[]): Action => {
  return {
    payload,
    type: Actions.MERGE_ARTICLE_DEFINITIONS,
  };
};

const setCurrentConfiguration = (
  payload?: Nullable<SimpleProjectServiceAPI.ConfigurationDto>,
): Action => {
  return {
    payload,
    type: Actions.SET_CURRENT_CONFIGURATION,
  };
};

const setCurrentRequestInfo = (
  payload?: Nullable<SimpleProjectServiceAPI.ConfigurationRequestDto>,
): Action => {
  return {
    payload,
    type: Actions.SET_CURRENT_REQUEST_INFO,
  };
};

const setCurrentProject = (payload?: Nullable<SimpleProjectServiceAPI.ProjectDto>): Action => {
  return {
    payload,
    type: Actions.SET_CURRENT_PROJECT,
  };
};

const setCurrentConfigurations = (
  payload?: Nullable<SimpleProjectServiceAPI.ConfigurationDto[]>,
): Action => {
  return {
    payload,
    type: Actions.SET_CURRENT_CONFIGURATIONS,
  };
};

const setConfigurationsData = (payload: Nullable<ConfigurationData[]>): Action => {
  return {
    payload,
    type: Actions.SET_CONFIGURATIONS_DATA,
  };
};

const setConfigurationsViewMode = (payload: ConfigurationsViewMode): Action => ({
  payload,
  type: Actions.SET_CONFIGURATIONS_VIEW_MODE,
});

const setSelectedConfigurationIds = (payload: string[]): Action => ({
  payload,
  type: Actions.SET_SELECTED_CONFIGURATION_IDS,
});

const setSelectedRequestIds = (payload: string[]): Action => ({
  payload,
  type: Actions.SET_SELECTED_REQUEST_IDS,
});

const setCurrentRequests = (payload: SimpleProjectServiceAPI.ConfigurationDto[]): Action => ({
  payload,
  type: Actions.SET_CURRENT_REQUESTS,
});

const setDrafts = (payload: Nullable<SimpleProjectServiceAPI.DraftConfigurationDto[]>): Action => ({
  payload,
  type: Actions.SET_DRAFTS,
});

const setValidationResults = (
  payload: Record<string, CoreServiceAPI.ValidationResultDto>,
): Action => ({
  payload,
  type: Actions.SET_VALIDATION_RESULTS,
});

const setPreviouslySelectedParameters = (payload: ProductParameter[]): Action => ({
  payload,
  type: Actions.SET_PREVIOUSLY_SELECTED_PARAMETERS,
});

const setLastError = (payload: any): Action => ({
  payload,
  type: Actions.SET_CONFIGURATION_ERROR,
});

export const configuratorActions = {
  mergeArticleDefinitions,
  setConfigurationData,
  setConfigurationsData,
  setConfigurationsViewMode,
  setCurrentConfiguration,
  setCurrentConfigurations,
  setCurrentProject,
  setCurrentRequestInfo,
  setCurrentRequests,
  setDrafts,
  setLastError,
  setPreviouslySelectedParameters,
  setSelectedConfigurationIds,
  setSelectedRequestIds,
  setValidationResults,
};
